export const exerciseLibrary = {
  chest: ["Incline Bench", "Coffin Press", "Dips", "Flys", "Chest General"],
  back: ["Pull-Ups", "Bent Over Row", "Overhead Pull-Down", "Shrugs", "Back General"],
  shoulders: ["Overhead Press", "Machine Side Raises", "Dumbbell Side Raises", "Face Pulls", "Side Lifts", "Shoulders General"],
  biceps: ["Curl-Ups", "Incline Curls", "Standing Curls", "Hammer Curls", "Biceps General"],
  triceps: ["Skull Crushers", "Overhead Lift", "Bench Dips", "Triceps General"],
  legs: ["Squats", "Deadlifts", "Legs General"],
  core: ["Leg Raises", "Sit-Ups", "Ab Wheel", "Russian Twists", "Core General"]
};